import {createAsyncThunk} from '@reduxjs/toolkit';
import {fetchStrictly} from '../../../../../../common/shared/api/fetchStrictly';
import {SerializedPagewebError} from '../../../../../../errors/SerializedPagewebError.interface';
import {TalkViewerErrorType} from '../../../../../../errors/TalkViewerErrorType.enum';
import {thunkSerializeError} from '../../../../../../errors/thunkSerializeError.function';
import {ViewerInfo} from '../../../../../../graphql/generated/types';
import {AppState} from '../../../../../../state/store';
import {TALK_VIEWER_STATE_NAME} from '../constant/talkViewerConstant';
import {TalkViewerResponseVo} from '../type/TalkViewerResponse.interface';
import {decryptTalkViewerPayload} from './decryptTalkViewerPayload';
import {getTalkViewerContentUrl} from './getTalkViewerContentUrl';

export const fetchTalkViewerContent = createAsyncThunk<
  {
    response: TalkViewerResponseVo;
    viewerInfoData: ViewerInfo;
  },
  {
    productId: number;
    viewerInfoData: ViewerInfo;
    decryptKey?: string;
    triggerType: 'page_move' | 'reload';
  },
  {state: AppState; serializedErrorType: SerializedPagewebError}
>(
  `${TALK_VIEWER_STATE_NAME}/fetchTalkViewerContent`,
  async (
    {productId, decryptKey, viewerInfoData},
    {getState, rejectWithValue}
  ) => {
    if (!decryptKey) {
      return rejectWithValue(TalkViewerErrorType.NoDecryptKey);
    }
    const contentUrl = await getTalkViewerContentUrl(productId, viewerInfoData);
    if (!contentUrl) {
      return rejectWithValue(TalkViewerErrorType.NoContentUrl);
    }
    const encryptedTalkViewerContentRawData = await fetchStrictly(contentUrl);
    const encryptedTalkViewerContent =
      await encryptedTalkViewerContentRawData.text();
    const decryptedTalkViewerContent = decryptTalkViewerPayload(
      encryptedTalkViewerContent,
      decryptKey
    );
    if (!decryptedTalkViewerContent) {
      return rejectWithValue(TalkViewerErrorType.DecryptFail);
    }
    return {
      response: JSON.parse(decryptedTalkViewerContent),
      viewerInfoData,
    };
  },
  {
    serializeError: thunkSerializeError,
  }
);
